export const dataTestId = {
  contentActionMenu: 'experiment-content-action-menu',
  contentSection: 'experiment-content-panel',
  contentBanner: 'experiment-content-banner',
  contentBannerText: 'experiment-content-banner-text',
  contentPreview: 'experiment-content-preview',
  copyAssistField: 'copy-assist',
  noData: 'experiment-not-found-message',
  overlay: 'experiment-overlay',
  takeoverDeleteButton: 'experiment-delete-button',
  takeoverLaunchButton: 'experiment-launch-button',
  takeoverSaveButton: 'experiment-save-button',
  takeoverSaveExitButtonSecondary: 'experiment-save-exit-button-secondary',
  takeoverSaveExitButtonOption: 'experiment-save-exit-button-option',
  takeoverUnsavedChanges: 'experiment-unsaved-changes',
  runningExperimentAnnouncement: 'running-experiment-announcement',
  settingsSection: 'experiment-settings-panel',
  variantActionButtons: 'variant-action-buttons',
  variantAlphabet: 'variant-alphabet',
  variantCard: 'variant-card',
  variantCardBodyNonEditable: 'variant-card-body-non-editable',
  variantCardBodySTOControl: 'variant-card-body-sto-control',
  variantCardBodySTONonControl: 'variant-card-body-sto-non-control',
  variantCardBodyUseEditor: 'variant-card-body-use-editor',
  variantCardFooterCancel: 'variant-card-footer-cancel',
  variantCardFooterLoading: 'variant-card-footer-loading-state',
  variantCardFooterEditable: 'variant-card-footer-for-editable-card',
  variantCardFooterNonEditable: 'variant-card-footer-for-non-editable-card',
  variantCardFooterSave: 'variant-card-footer-save',
  variantCardFooterSaveAndAddVariant: 'variant-card-footer-save-and-add-variant',
  variantCardFooterSTO: 'variant-card-footer-for-sto-variant',
  variantConfigurationActionButtons: 'variant-configuration-action-buttons',
  variantConfigurationSection: 'variant-configuration-panel',
  variantDeleteButton: 'variant-delete-button',
  variantEditButton: 'variant-edit-button',
  variantNameEditButton: 'variant-name-edit-button',
  variantNameEditInput: 'variant-name-edit-input',
};
